import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42dda38b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Width")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Height")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Display")
], -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Flex direction")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Flex")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Flex wrap")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Justify Content")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Align items")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Row gap")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Column gap")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Flex grow")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Flex shrink")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Flex order")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Flex basis")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Align self")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Overflow")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Overflow-X")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Overflow-Y")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "ZIndex")
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Position")
], -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Top")
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Left")
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Bottom")
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Right")
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Margin")
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Padding")
], -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Background color")
], -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Background image")
], -1))
const _hoisted_32 = { class: "image-field" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Background position")
], -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Background size")
], -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Background repeat")
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Opacity")
], -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Border style")
], -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Border width")
], -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Border color")
], -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Border radius")
], -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Font family")
], -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Font size")
], -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Font color")
], -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Font weight")
], -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Font style")
], -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Text align")
], -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Line height")
], -1))
const _hoisted_48 = {
  key: 1,
  style: {"padding":"20px","text-align":"center"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_fk_color_picker = _resolveComponent("fk-color-picker")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_AssetManagerComponent = _resolveComponent("AssetManagerComponent")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.containerRef)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_a_row, { gutter: 10 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _createVNode(_component_a_input, {
                    value: _ctx.containerRef.styles.width,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.containerRef.styles.width) = $event)),
                    placeholder: "100%",
                    onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updatePage()))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _hoisted_3,
                  _createVNode(_component_a_input, {
                    value: _ctx.containerRef.styles.height,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.containerRef.styles.height) = $event)),
                    placeholder: "100%",
                    onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updatePage()))
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { gutter: 10 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _hoisted_4,
                  _createVNode(_component_a_select, {
                    value: _ctx.containerRef.styles.display,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.containerRef.styles.display) = $event)),
                    style: {"width":"100%"},
                    defaultValue: "block",
                    onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updatePage()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: "flex" }, {
                        default: _withCtx(() => [
                          _createTextVNode("flex")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "block" }, {
                        default: _withCtx(() => [
                          _createTextVNode("block")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "inline-block" }, {
                        default: _withCtx(() => [
                          _createTextVNode("inline-block")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.containerRef.styles.display == 'flex')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_a_row, { gutter: 10 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_6,
                        _hoisted_7,
                        _createVNode(_component_a_radio_group, {
                          defaultValue: "column",
                          value: _ctx.containerRef.styles.flexDirection,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.containerRef.styles.flexDirection) = $event)),
                          "button-style": "solid",
                          onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updatePage()))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_button, { value: 'column' }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Column ")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio_button, { value: 'row' }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Row ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, { gutter: 10 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _hoisted_8,
                        _createVNode(_component_a_input, {
                          value: _ctx.containerRef.styles.flex,
                          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.containerRef.styles.flex) = $event)),
                          placeholder: "1",
                          onBlur: _cache[9] || (_cache[9] = ($event: any) => (_ctx.updatePage()))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _hoisted_9,
                        _createVNode(_component_a_select, {
                          value: _ctx.containerRef.styles.flexWrap,
                          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.containerRef.styles.flexWrap) = $event)),
                          style: {"width":"100%"},
                          defaultValue: "no-wrap",
                          onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.updatePage()))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select_option, { value: "nowrap" }, {
                              default: _withCtx(() => [
                                _createTextVNode("no-wrap")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_select_option, { value: "wrap" }, {
                              default: _withCtx(() => [
                                _createTextVNode("wrap")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_select_option, { value: "wrap-reverse" }, {
                              default: _withCtx(() => [
                                _createTextVNode("wrap-reverse")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, { gutter: 10 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _hoisted_10,
                        _createVNode(_component_a_select, {
                          value: _ctx.containerRef.styles.justifyContent,
                          "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.containerRef.styles.justifyContent) = $event)),
                          style: {"width":"100%"},
                          defaultValue: "flex-start",
                          onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.updatePage()))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select_option, { value: "flex-start" }, {
                              default: _withCtx(() => [
                                _createTextVNode("flex-start")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_select_option, { value: "flex-end" }, {
                              default: _withCtx(() => [
                                _createTextVNode("flex-end")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_select_option, { value: "center" }, {
                              default: _withCtx(() => [
                                _createTextVNode("center")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_select_option, { value: "space-between" }, {
                              default: _withCtx(() => [
                                _createTextVNode("space-between")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_select_option, { value: "space-around" }, {
                              default: _withCtx(() => [
                                _createTextVNode("space-around")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_select_option, { value: "space-evenly" }, {
                              default: _withCtx(() => [
                                _createTextVNode("space-evenly")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _hoisted_11,
                        _createVNode(_component_a_select, {
                          value: _ctx.containerRef.styles.alignItems,
                          "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.containerRef.styles.alignItems) = $event)),
                          style: {"width":"100%"},
                          defaultValue: "stretch",
                          onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.updatePage()))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select_option, { value: "stretch" }, {
                              default: _withCtx(() => [
                                _createTextVNode("stretch")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_select_option, { value: "center" }, {
                              default: _withCtx(() => [
                                _createTextVNode("center")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_select_option, { value: "flex-start" }, {
                              default: _withCtx(() => [
                                _createTextVNode("flex-start")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_select_option, { value: "flex-end" }, {
                              default: _withCtx(() => [
                                _createTextVNode("flex-end")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_select_option, { value: "baseline" }, {
                              default: _withCtx(() => [
                                _createTextVNode("baseline")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, { gutter: 10 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _hoisted_12,
                        _createVNode(_component_a_input, {
                          value: _ctx.containerRef.styles.rowGap,
                          "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.containerRef.styles.rowGap) = $event)),
                          placeholder: "0px",
                          onBlur: _cache[17] || (_cache[17] = ($event: any) => (_ctx.updatePage()))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _hoisted_13,
                        _createVNode(_component_a_input, {
                          value: _ctx.containerRef.styles.columnGap,
                          "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.containerRef.styles.columnGap) = $event)),
                          placeholder: "0px",
                          onBlur: _cache[19] || (_cache[19] = ($event: any) => (_ctx.updatePage()))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, { gutter: 10 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _hoisted_14,
                        _createVNode(_component_a_input, {
                          value: _ctx.containerRef.styles.flexGrow,
                          "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.containerRef.styles.flexGrow) = $event)),
                          placeholder: "0",
                          onBlur: _cache[21] || (_cache[21] = ($event: any) => (_ctx.updatePage()))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _hoisted_15,
                        _createVNode(_component_a_input, {
                          value: _ctx.containerRef.styles.flexShrink,
                          "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.containerRef.styles.flexShrink) = $event)),
                          placeholder: "0",
                          onBlur: _cache[23] || (_cache[23] = ($event: any) => (_ctx.updatePage()))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, { gutter: 10 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _hoisted_16,
                        _createVNode(_component_a_input, {
                          value: _ctx.containerRef.styles.order,
                          "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.containerRef.styles.order) = $event)),
                          placeholder: "order",
                          onBlur: _cache[25] || (_cache[25] = ($event: any) => (_ctx.updatePage()))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _hoisted_17,
                        _createVNode(_component_a_input, {
                          value: _ctx.containerRef.styles.flexBasis,
                          "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.containerRef.styles.flexBasis) = $event)),
                          placeholder: "auto",
                          onBlur: _cache[27] || (_cache[27] = ($event: any) => (_ctx.updatePage()))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, { gutter: 10 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _hoisted_18,
                        _createVNode(_component_a_select, {
                          value: _ctx.containerRef.styles.alignSelf,
                          "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.containerRef.styles.alignSelf) = $event)),
                          style: {"width":"100%"},
                          defaultValue: "auto",
                          onChange: _cache[29] || (_cache[29] = ($event: any) => (_ctx.updatePage()))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select_option, { value: "auto" }, {
                              default: _withCtx(() => [
                                _createTextVNode("auto")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_select_option, { value: "stretch" }, {
                              default: _withCtx(() => [
                                _createTextVNode("stretch")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_select_option, { value: "center" }, {
                              default: _withCtx(() => [
                                _createTextVNode("center")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_select_option, { value: "flex-start" }, {
                              default: _withCtx(() => [
                                _createTextVNode("flex-start")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_select_option, { value: "flex-end" }, {
                              default: _withCtx(() => [
                                _createTextVNode("flex-end")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_select_option, { value: "baseline" }, {
                              default: _withCtx(() => [
                                _createTextVNode("flex-end")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 })
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_a_row, { gutter: 10 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _hoisted_19,
                  _createVNode(_component_a_select, {
                    value: _ctx.containerRef.styles.overflow,
                    "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.containerRef.styles.overflow) = $event)),
                    style: {"width":"100%"},
                    defaultValue: "visible",
                    onChange: _cache[31] || (_cache[31] = ($event: any) => (_ctx.updatePage()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: "visible" }, {
                        default: _withCtx(() => [
                          _createTextVNode("visible")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "hidden" }, {
                        default: _withCtx(() => [
                          _createTextVNode("hidden")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "auto" }, {
                        default: _withCtx(() => [
                          _createTextVNode("auto")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _hoisted_20,
                  _createVNode(_component_a_select, {
                    value: _ctx.containerRef.styles.overflowX,
                    "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.containerRef.styles.overflowX) = $event)),
                    style: {"width":"100%"},
                    defaultValue: "visible",
                    onChange: _cache[33] || (_cache[33] = ($event: any) => (_ctx.updatePage()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: "visible" }, {
                        default: _withCtx(() => [
                          _createTextVNode("visible")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "hidden" }, {
                        default: _withCtx(() => [
                          _createTextVNode("hidden")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "scroll" }, {
                        default: _withCtx(() => [
                          _createTextVNode("scroll")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "auto" }, {
                        default: _withCtx(() => [
                          _createTextVNode("auto")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { gutter: 10 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _hoisted_21,
                  _createVNode(_component_a_select, {
                    value: _ctx.containerRef.styles.overflowY,
                    "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.containerRef.styles.overflowY) = $event)),
                    style: {"width":"100%"},
                    defaultValue: "visible",
                    onChange: _cache[35] || (_cache[35] = ($event: any) => (_ctx.updatePage()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: "visible" }, {
                        default: _withCtx(() => [
                          _createTextVNode("visible")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "hidden" }, {
                        default: _withCtx(() => [
                          _createTextVNode("hidden")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "scroll" }, {
                        default: _withCtx(() => [
                          _createTextVNode("scroll")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "auto" }, {
                        default: _withCtx(() => [
                          _createTextVNode("auto")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _hoisted_22,
                  _createVNode(_component_a_input, {
                    value: _ctx.containerRef.styles.zIndex,
                    "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.containerRef.styles.zIndex) = $event)),
                    placeholder: "0",
                    onBlur: _cache[37] || (_cache[37] = ($event: any) => (_ctx.updatePage()))
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { gutter: 10 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _hoisted_23,
                  _createVNode(_component_a_select, {
                    style: {"width":"100%"},
                    defaultValue: "relative",
                    value: _ctx.containerRef.styles.position,
                    "onUpdate:value": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.containerRef.styles.position) = $event)),
                    onChange: _cache[39] || (_cache[39] = ($event: any) => (_ctx.updatePage()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: "relative" }, {
                        default: _withCtx(() => [
                          _createTextVNode("relative")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "absolute" }, {
                        default: _withCtx(() => [
                          _createTextVNode("absolute")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "fixed" }, {
                        default: _withCtx(() => [
                          _createTextVNode("fixed")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (
				_ctx.containerRef.styles.position == 'absolute' ||
					_ctx.containerRef.styles.position == 'fixed'
			)
            ? (_openBlock(), _createBlock(_component_a_row, {
                key: 1,
                gutter: 10
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _hoisted_24,
                      _createVNode(_component_a_input, {
                        value: _ctx.containerRef.styles.top,
                        "onUpdate:value": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.containerRef.styles.top) = $event)),
                        placeholder: "0px",
                        onBlur: _cache[41] || (_cache[41] = ($event: any) => (_ctx.updatePage()))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _hoisted_25,
                      _createVNode(_component_a_input, {
                        value: _ctx.containerRef.styles.left,
                        "onUpdate:value": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.containerRef.styles.left) = $event)),
                        placeholder: "0px",
                        onBlur: _cache[43] || (_cache[43] = ($event: any) => (_ctx.updatePage()))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _hoisted_26,
                      _createVNode(_component_a_input, {
                        value: _ctx.containerRef.styles.bottom,
                        "onUpdate:value": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.containerRef.styles.bottom) = $event)),
                        placeholder: "auto",
                        onBlur: _cache[45] || (_cache[45] = ($event: any) => (_ctx.updatePage()))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _hoisted_27,
                      _createVNode(_component_a_input, {
                        value: _ctx.containerRef.styles.right,
                        "onUpdate:value": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.containerRef.styles.right) = $event)),
                        placeholder: "auto",
                        onBlur: _cache[47] || (_cache[47] = ($event: any) => (_ctx.updatePage()))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_a_row, { gutter: 10 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _hoisted_28,
                  _createVNode(_component_a_input, {
                    value: _ctx.containerRef.styles.margin,
                    "onUpdate:value": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.containerRef.styles.margin) = $event)),
                    placeholder: "0px 0px 0px 0px",
                    onBlur: _cache[49] || (_cache[49] = ($event: any) => (_ctx.updatePage()))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _hoisted_29,
                  _createVNode(_component_a_input, {
                    value: _ctx.containerRef.styles.padding,
                    "onUpdate:value": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.containerRef.styles.padding) = $event)),
                    placeholder: "0px 0px 0px 0px",
                    onBlur: _cache[51] || (_cache[51] = ($event: any) => (_ctx.updatePage()))
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { gutter: 10 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _hoisted_30,
                  _createVNode(_component_a_popover, { trigger: "click" }, {
                    content: _withCtx(() => [
                      _createVNode(_component_fk_color_picker, {
                        color: _ctx.containerRef.styles.backgroundColor,
                        "onUpdate:color": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.containerRef.styles.backgroundColor) = $event)),
                        format: "hex8",
                        onChange: _cache[53] || (_cache[53] = ($event: any) => (_ctx.updatePage()))
                      }, null, 8, ["color"])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        style: _normalizeStyle({
							backgroundColor: _ctx.containerRef.styles.backgroundColor
						}),
                        value: _ctx.containerRef.styles.backgroundColor,
                        "onUpdate:value": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.containerRef.styles.backgroundColor) = $event)),
                        placeholder: "#fff"
                      }, null, 8, ["style", "value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _hoisted_31,
                  (!_ctx.containerRef.styles.backgroundImageAsset)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        onClick: _cache[55] || (_cache[55] = ($event: any) => (_ctx.chooseBackgroundImage('backgroundImage')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Choose image")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_32, [
                    (_ctx.containerRef.styles.backgroundImageAsset)
                      ? (_openBlock(), _createBlock(_component_a_input, {
                          key: 0,
                          onClick: _cache[56] || (_cache[56] = ($event: any) => (_ctx.chooseBackgroundImage('backgroundImage'))),
                          value: 
							_ctx.containerRef.styles.backgroundImageAsset.url
						,
                          "onUpdate:value": _cache[57] || (_cache[57] = ($event: any) => ((
							_ctx.containerRef.styles.backgroundImageAsset.url
						) = $event)),
                          placeholder: "none",
                          onBlur: _cache[58] || (_cache[58] = ($event: any) => (_ctx.updatePage()))
                        }, null, 8, ["value"]))
                      : _createCommentVNode("", true),
                    (_ctx.containerRef.styles.backgroundImageAsset)
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 1,
                          onClick: _cache[59] || (_cache[59] = ($event: any) => (_ctx.removeImage())),
                          size: "small",
                          style: {"height":"32px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, { icon: "times" })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { gutter: 10 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _hoisted_33,
                  _createVNode(_component_a_input, {
                    value: _ctx.containerRef.styles.backgroundPosition,
                    "onUpdate:value": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.containerRef.styles.backgroundPosition) = $event)),
                    placeholder: "top left",
                    onBlur: _cache[61] || (_cache[61] = ($event: any) => (_ctx.updatePage()))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _hoisted_34,
                  _createVNode(_component_a_input, {
                    value: _ctx.containerRef.styles.backgroundSize,
                    "onUpdate:value": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.containerRef.styles.backgroundSize) = $event)),
                    placeholder: "auto",
                    onBlur: _cache[63] || (_cache[63] = ($event: any) => (_ctx.updatePage()))
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { gutter: 10 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _hoisted_35,
                  _createVNode(_component_a_select, {
                    style: {"width":"100%"},
                    defaultValue: "no-repeat",
                    value: _ctx.containerRef.styles.backgroundRepeat,
                    "onUpdate:value": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.containerRef.styles.backgroundRepeat) = $event)),
                    onChange: _cache[65] || (_cache[65] = ($event: any) => (_ctx.updatePage()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: "no-repeat" }, {
                        default: _withCtx(() => [
                          _createTextVNode("no-repeat")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "repeat" }, {
                        default: _withCtx(() => [
                          _createTextVNode("repeat")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "repeat-x" }, {
                        default: _withCtx(() => [
                          _createTextVNode("repeat-x")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "repeat-y" }, {
                        default: _withCtx(() => [
                          _createTextVNode("repeat-y")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "space" }, {
                        default: _withCtx(() => [
                          _createTextVNode("space")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "round" }, {
                        default: _withCtx(() => [
                          _createTextVNode("round")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _hoisted_36,
                  _createVNode(_component_a_input, {
                    value: _ctx.containerRef.styles.opacity,
                    "onUpdate:value": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.containerRef.styles.opacity) = $event)),
                    placeholder: "opacity",
                    onBlur: _cache[67] || (_cache[67] = ($event: any) => (_ctx.updatePage()))
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { gutter: 10 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _hoisted_37,
                  _createVNode(_component_a_select, {
                    style: {"width":"100%"},
                    defaultValue: "none",
                    value: _ctx.containerRef.styles.borderStyle,
                    "onUpdate:value": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.containerRef.styles.borderStyle) = $event)),
                    onChange: _cache[69] || (_cache[69] = ($event: any) => (_ctx.updatePage()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: "none" }, {
                        default: _withCtx(() => [
                          _createTextVNode("none")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "solid" }, {
                        default: _withCtx(() => [
                          _createTextVNode("solid")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "dotted" }, {
                        default: _withCtx(() => [
                          _createTextVNode("dotted")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "dashed" }, {
                        default: _withCtx(() => [
                          _createTextVNode("dashed")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _hoisted_38,
                  _createVNode(_component_a_input, {
                    value: _ctx.containerRef.styles.borderWidth,
                    "onUpdate:value": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.containerRef.styles.borderWidth) = $event)),
                    placeholder: "0px",
                    onBlur: _cache[71] || (_cache[71] = ($event: any) => (_ctx.updatePage()))
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { gutter: 10 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _hoisted_39,
                  _createVNode(_component_a_popover, { trigger: "click" }, {
                    content: _withCtx(() => [
                      _createVNode(_component_fk_color_picker, {
                        color: _ctx.containerRef.styles.borderColor,
                        "onUpdate:color": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.containerRef.styles.borderColor) = $event)),
                        format: "hex8",
                        onChange: _cache[73] || (_cache[73] = ($event: any) => (_ctx.updatePage()))
                      }, null, 8, ["color"])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        style: _normalizeStyle({
							backgroundColor: _ctx.containerRef.styles.borderColor
						}),
                        value: _ctx.containerRef.styles.borderColor,
                        "onUpdate:value": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.containerRef.styles.borderColor) = $event)),
                        placeholder: "#fff"
                      }, null, 8, ["style", "value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _hoisted_40,
                  _createVNode(_component_a_input, {
                    value: _ctx.containerRef.styles.borderRadius,
                    "onUpdate:value": _cache[75] || (_cache[75] = ($event: any) => ((_ctx.containerRef.styles.borderRadius) = $event)),
                    placeholder: "0px 0px 0px 0px",
                    onBlur: _cache[76] || (_cache[76] = ($event: any) => (_ctx.updatePage()))
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { gutter: 10 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _hoisted_41,
                  _createVNode(_component_a_input, {
                    value: _ctx.containerRef.styles.fontFamily,
                    "onUpdate:value": _cache[77] || (_cache[77] = ($event: any) => ((_ctx.containerRef.styles.fontFamily) = $event)),
                    placeholder: "",
                    onBlur: _cache[78] || (_cache[78] = ($event: any) => (_ctx.updatePage()))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _hoisted_42,
                  _createVNode(_component_a_input, {
                    value: _ctx.containerRef.styles.fontSize,
                    "onUpdate:value": _cache[79] || (_cache[79] = ($event: any) => ((_ctx.containerRef.styles.fontSize) = $event)),
                    placeholder: "12px",
                    onBlur: _cache[80] || (_cache[80] = ($event: any) => (_ctx.updatePage()))
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { gutter: 10 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _hoisted_43,
                  _createVNode(_component_a_popover, { trigger: "click" }, {
                    content: _withCtx(() => [
                      _createVNode(_component_fk_color_picker, {
                        color: _ctx.containerRef.styles.color,
                        "onUpdate:color": _cache[81] || (_cache[81] = ($event: any) => ((_ctx.containerRef.styles.color) = $event)),
                        format: "hex8",
                        onChange: _cache[82] || (_cache[82] = ($event: any) => (_ctx.updatePage()))
                      }, null, 8, ["color"])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        style: _normalizeStyle({ backgroundColor: _ctx.containerRef.styles.color }),
                        value: _ctx.containerRef.styles.color,
                        "onUpdate:value": _cache[83] || (_cache[83] = ($event: any) => ((_ctx.containerRef.styles.color) = $event)),
                        placeholder: "#fff",
                        onChange: _cache[84] || (_cache[84] = ($event: any) => (_ctx.updatePage()))
                      }, null, 8, ["style", "value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _hoisted_44,
                  _createVNode(_component_a_input, {
                    value: _ctx.containerRef.styles.fontWeight,
                    "onUpdate:value": _cache[85] || (_cache[85] = ($event: any) => ((_ctx.containerRef.styles.fontWeight) = $event)),
                    placeholder: "10px",
                    onBlur: _cache[86] || (_cache[86] = ($event: any) => (_ctx.updatePage()))
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { gutter: 10 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _hoisted_45,
                  _createVNode(_component_a_select, {
                    style: {"width":"100%"},
                    defaultValue: "normal",
                    value: _ctx.containerRef.styles.fontStyle,
                    "onUpdate:value": _cache[87] || (_cache[87] = ($event: any) => ((_ctx.containerRef.styles.fontStyle) = $event)),
                    onChange: _cache[88] || (_cache[88] = ($event: any) => (_ctx.updatePage()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: "normal" }, {
                        default: _withCtx(() => [
                          _createTextVNode("normal")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "italic" }, {
                        default: _withCtx(() => [
                          _createTextVNode("italic")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "oblique" }, {
                        default: _withCtx(() => [
                          _createTextVNode("oblique")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 12 })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { gutter: 10 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _hoisted_46,
                  _createVNode(_component_a_select, {
                    style: {"width":"100%"},
                    defaultValue: "left",
                    value: _ctx.containerRef.styles.textAlign,
                    "onUpdate:value": _cache[89] || (_cache[89] = ($event: any) => ((_ctx.containerRef.styles.textAlign) = $event)),
                    onChange: _cache[90] || (_cache[90] = ($event: any) => (_ctx.updatePage()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: "left" }, {
                        default: _withCtx(() => [
                          _createTextVNode("left")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "right" }, {
                        default: _withCtx(() => [
                          _createTextVNode("right")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "center" }, {
                        default: _withCtx(() => [
                          _createTextVNode("center")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "justify" }, {
                        default: _withCtx(() => [
                          _createTextVNode("justify")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _hoisted_47,
                  _createVNode(_component_a_input, {
                    value: _ctx.containerRef.styles.lineHeight,
                    "onUpdate:value": _cache[91] || (_cache[91] = ($event: any) => ((_ctx.containerRef.styles.lineHeight) = $event)),
                    placeholder: "normal",
                    onBlur: _cache[92] || (_cache[92] = ($event: any) => (_ctx.updatePage()))
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (!_ctx.containerRef)
      ? (_openBlock(), _createElementBlock("div", _hoisted_48, " Please select an element or container "))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      footer: null,
      visible: _ctx.showModal,
      title: 'Assets',
      onCancel: _cache[94] || (_cache[94] = ($event: any) => (_ctx.showModal = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AssetManagerComponent, {
          onSetAsset: _cache[93] || (_cache[93] = ($event: any) => (_ctx.setAsset($event)))
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}